import { DownloadMobileApp } from "../src/components"

export default function DownloadMobileAppPage() {
    return (
        <div className="cure-inner-container">
            <DownloadMobileApp />
        </div>
    )
}